module.exports = __webpack_public_path__ + "img/arrows.d4076ccc.svg";